import React, { useState } from 'react';
import { Form, Button, Spinner, Alert } from 'react-bootstrap';
import logoColor from '../../assets/logo-color.svg';

const AUTH_BASE = process.env.REACT_APP_AUTH_API_BASE || 'http://localhost:8003';

const pageStyle = {
  background: 'linear-gradient(135deg, #1e293b 0%, #334155 50%, #1e293b 100%)',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',
};

const cardStyle = {
  width: 420,
  background: '#fff',
  borderRadius: 24,
  boxShadow: '0 25px 50px -12px rgba(0,0,0,0.25)',
  border: 'none',
  padding: '2.5rem',
  position: 'relative',
  zIndex: 1,
};

const titleStyle = {
  fontFamily: "'Inter', sans-serif",
  fontWeight: 800,
  fontSize: '2rem',
  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  marginBottom: '0.25rem',
};

const subtitleStyle = {
  color: '#64748b',
  fontSize: '0.9rem',
  fontWeight: 500,
  margin: 0,
};

const labelStyle = {
  fontFamily: "'Inter', sans-serif",
  fontWeight: 600,
  fontSize: '0.8125rem',
  color: '#475569',
};

const inputStyle = {
  borderRadius: 10,
  border: '1px solid #e2e8f0',
  padding: '0.625rem 1rem',
  fontSize: '0.9rem',
};

const btnStyle = {
  background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
  border: 'none',
  fontFamily: "'Inter', sans-serif",
  fontWeight: 600,
  fontSize: '0.9rem',
  borderRadius: 12,
  padding: '0.75rem',
  boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
};

export default function Login() {
  const [zendeskSubdomain, setZendeskSubdomain] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleZendeskSubmit = (e) => {
    e.preventDefault();
    if (!zendeskSubdomain.trim()) {
      setError('Please enter your Zendesk subdomain');
      return;
    }
    setError('');
    setLoading(true);
    window.location.href = `${AUTH_BASE}/oauth/initiate?subdomain=${encodeURIComponent(zendeskSubdomain.trim())}`;
  };

  return (
    <div style={pageStyle}>
      <div style={cardStyle}>
        <div className="text-center mb-4">
          <img src={logoColor} alt="TopCX" style={{ height: 48, marginBottom: 12 }} />
          <h3 style={titleStyle}>TopCX</h3>
          <p style={subtitleStyle}>Sign in with your Zendesk account</p>
        </div>

        {error && (
          <Alert variant="danger" dismissible onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        <Form onSubmit={handleZendeskSubmit}>
          <Form.Group className="mb-3">
            <Form.Label style={labelStyle}>Zendesk Subdomain</Form.Label>
            <div className="d-flex align-items-center">
              <Form.Control
                style={inputStyle}
                type="text"
                value={zendeskSubdomain}
                onChange={(e) => setZendeskSubdomain(e.target.value)}
                placeholder="yourcompany"
                required
                autoFocus
              />
              <span
                style={{
                  color: '#94a3b8',
                  fontSize: '0.85rem',
                  marginLeft: 8,
                  whiteSpace: 'nowrap',
                }}
              >
                .zendesk.com
              </span>
            </div>
          </Form.Group>

          <Button type="submit" className="w-100" disabled={loading} style={btnStyle}>
            {loading ? (
              <>
                <Spinner size="sm" className="me-2" />
                Redirecting...
              </>
            ) : (
              'Sign in with Zendesk'
            )}
          </Button>
        </Form>
      </div>
    </div>
  );
}
